import { render, staticRenderFns } from "./createOrder.vue?vue&type=template&id=0b7e1b92&scoped=true"
import script from "./createOrder.vue?vue&type=script&lang=js"
export * from "./createOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7e1b92",
  null
  
)

export default component.exports